module.exports = "<h1 class=naslov>${this.podaci.naslov}</h1> <div class=okvir> <img class=full src=${this.podaci.slika} alt=slika> </div> <p class=opis>${this.podaci.opis}</p> <p class=pitanje>${this.podaci.pitanje || ''}</p> <button class=kockice id=kockice><img src=/slike/kockice.gif><br> <span>${this.podaci.akcija}</span> </button> ";


//////////////////
// WEBPACK FOOTER
// ./src/komponente/sudbina/sablon.html
// module id = 36
// module chunks = 0